<template>
    <div class="border border-gray-200 shadow-sm py-4 px-5 flex flex-col rounded-md gap-y-2 cursor-pointer">
        <p class="text-base leading-6 font-medium text-gray-900">{{ title }}</p>
        <p class="text-sm leading-5 font-normal text-gray-500"><b>Example:</b> {{ example }}</p>
    </div>
</template>
<script setup lang="ts">
interface Props {
    title: string
    example: string
}
defineProps<Props>()
</script>
